import React from "react";
import "./footer.css";
import logoSignature from "../../Assets/BlackSwan.png";
import { SiLinkedin, SiInstagram, SiTwitter, SiFacebook } from "react-icons/si";

const Footer = (props) => {
  const t = props.language;
  const openMenu = props.openMenu;
  return (
    <footer className="footer">
      {!openMenu ? (
        <div className="footer__title">
          <div className="title__body">
            <div className="logos">
              <img src={logoSignature} alt="logo" className="logo" />
            </div>
            <div className="social--info">
              <div className="copyright">
                <div>
                  <h6 className="pp">Privacy Policy</h6>
                  <h6 className="pp">Cookie Policy</h6>
                </div>
                {/* <span>{t("legal_notice")}</span> */}
                {/* <a href="#" className="social__link">
                  <SiLinkedin className="lnk" />
                </a> */}
              </div>
            </div>
          </div>
          <div className="title__body">
            {/* <h2>{t("contact_us")}</h2> */}
            <span>
              Black Swan Real Estate Capital | 65, rue de la Boétie, 75008 Paris
              | Mail : bsrec-contact@bsrecapital.com | Téléphone :
              01.86.22.80.00
            </span>
          </div>
          <div className="title__body">
            <span>4 Avenue Hoche, 75008 Paris</span>
          </div>
          <div>
            <span className="font">
              Powered by{" "}
              <a className="tickit" href="mailto: sales@tickit.co">
                Tick'It
              </a>{" "}
            </span>
          </div>
        </div>
      ) : (
        <></>
      )}
      {/* <div className="logo__socials"></div> */}
    </footer>
  );
};

export default Footer;
